// extracted by mini-css-extract-plugin
module.exports = {"numberItem":"requirementsimplified_numberItem__1rlBz","descriptionItem":"requirementsimplified_descriptionItem__5GkQ0"};